import { get } from "lodash";

export default class Contact {
  id?: string;
  name: string;
  position: string;
  email: string;
  phone: string;
  language: string;
  company_id?: string;

  constructor(params?: Contact) {
    this.id = get(params, "id", undefined);
    this.name = get(params, "name", "");
    this.position = get(params, "position", "");
    this.email = get(params, "email", "");
    this.phone = get(params, "phone", "");
    this.language = get(params, "language", "");
    this.company_id = get(params, "company_id", "");
  }
}
